import React from "react"
import styled, { keyframes, css } from "styled-components"
import { responsive } from "buoy-theme"
import { Dropdown, Paragraph, Arrow } from "buoy-core"
import { pushRoute } from "../../../../common/route"
import Title from "./Title"

const options = [
  { text: "Profile Information", value: "/profile/" },
  { text: "Visit History", value: "/profile/visits/" },
  { text: "Account Settings", value: "/profile/settings/" },
]

const Name = styled(Paragraph)`
  cursor: pointer;
  margin: 0;
`

const NavContainer = styled.div`
  ${responsive("display", "none", "none", "flex", "flex", "flex")};
  flex-direction: column;
  position: fixed;
  ${responsive("top", "59px", "59px", "59px", "59px", "56px")};
  z-index: 2;
  background: white;
  width: 100%;
  left: 0;
  right: 0;
  padding: 16px;
  box-shadow: ${props => (!props.showName ? "0 0 15px 0 #00000021" : "none")};
  transition: transform 0.2s ease;
  transform: ${props =>
    props.showName ? "translateY(0)" : "translateY(-37px)"};
`

const slideUp = keyframes`
    0% {
        opacity: 0;
        transform: translateY(50%)
    }
    100% {
        opacity:1;
        transform: translateY(0)
    }
`

const Overlay = styled.div`
  position: fixed;
  z-index: 102;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #19191960;
`

const NameButton = styled.button`
  padding: none;
  background: none;
  border: none;
  display: flex;
  align-items: center;
  appearance: none;
  margin: 0 0 10px;
  padding: 0;
`

const ArrowContainer = styled.div`
  background: transparent;
  margin-left: 6px;
  ${({ expanded }) =>
    expanded &&
    css`
      div {
        transition: all 0.5s ease;
        transform: rotate(-180deg);
      }
    `};
`

const SelectContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  z-index: 103;
  max-height: 60vh;
  overflow-y: scroll;
  box-shadow: 0 0 15px 0 #00000021;
  animation: ${slideUp} 0.25s forwards ease-in;
`

const InnerSelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  overflow-y: scroll;
`

const toLink = link => {
  pushRoute(link, true)
}

const MobileProfileSelect = ({
  selected,
  toggleExpanded,
  expanded,
  profiles,
  showName,
  select,
}) => (
  <React.Fragment>
    <NavContainer showName={showName}>
      <NameButton onClick={toggleExpanded}>
        <Name fontSize="bodyLarge" weight="regular">
          {selected.name}
        </Name>
        <ArrowContainer expanded={expanded}>
          <Arrow color="primary" />
        </ArrowContainer>
      </NameButton>
      <Dropdown
        placeholder="Select"
        options={options}
        onChange={toLink}
        value={window.location.pathname}
      />
    </NavContainer>
    {expanded && (
      <Overlay onClick={toggleExpanded}>
        <SelectContainer>
          <InnerSelectContainer>
            {profiles.map((p, i) => (
              <Title
                {...p}
                key={p.id}
                selected={selected && selected.id === p.id}
                noDim
                onClick={select(i)}
              />
            ))}
          </InnerSelectContainer>
        </SelectContainer>
      </Overlay>
    )}
  </React.Fragment>
)

class MobileProfileSelectWrapper extends React.Component {
  state = {
    expanded: false,
    showName: true,
  }

  componentDidMount = () => {
    window.addEventListener("scroll", this.handleScroll)
  }

  componentWillUnmount = () => {
    window.removeEventListener("scroll", this.handleScroll)
  }

  handleScroll = () => {
    if (window.scrollY > 50 && this.state.showName) {
      this.setState({ showName: false })
    } else if (window.scrollY < 50 && !this.state.showName) {
      this.setState({ showName: true })
    }

    this.scrollPos = window.scrollY
  }

  toggleExpanded = () => this.setState({ expanded: !this.state.expanded })

  select = i => () => {
    this.props.select(i)()
    this.setState({ expanded: false })
  }

  render() {
    return (
      <MobileProfileSelect
        {...this.props}
        {...this.state}
        toggleExpanded={this.toggleExpanded}
        select={this.select}
      />
    )
  }
}

export { MobileProfileSelectWrapper as default }



// WEBPACK FOOTER //
// ./assets/common/components/ProfileSwitcher/components/MobileProfileSelect.js